import { Client } from '@/../client-generator/generated-clients/device-settings';
import axiosInstance from '../utils/axios-instance';

const deviceSettingsClient = new Client('', axiosInstance);

export default deviceSettingsClient;
